
// import all css and other components
import "./css/Home.css";
import { connect } from "react-redux";
import React from "react";
import {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateUid,
  activateDatadicbackup,
  activateFiname,
  activateScreen,
  activateShowfilter,
  activateRecordtb,
  activateUnivid,
  activateUnivtype,
} from "./redux";
import Fselectf from "./components/Fselectf";
import { Layout, Button, Modal, Select, Row, Col, Space,Collapse ,PageHeader, Descriptions,Tag,Result,Menu,Dropdown,Card  } from "antd";
import Selection from "./components/Selection";
import DropDwnTr from "./components/DropdownTr";
import Dropdowns from "./components/Dropdowns";
import Sliderlo from "./components/Sliderlo";
import Sliderbub from "./components/Sliderbub";
import Checkboxs from "./components/Checkboxs";

import TableAPP from "./components/Table";
import SaveFilter from "./components/SaveFilter";
import ScreenMenu from "./components/ScreenMenu"; 
import Popmsg from "./components/Popmsg";
import Myportfolio from "./components/Myportfolio";
import Togglecom from "./components/Toggle";



import { Link  } from 'react-router-dom'
import {
  UserOutlined,PlayCircleTwoTone 
} from '@ant-design/icons';
 
//

const { Panel } = Collapse;
const { Header, Content } = Layout;

class Homeclass extends React.Component {
  constructor(props) {
  
    super(props);
    this.child = React.createRef();
    this.props.activatePath(this.props.paths);
    this.props.activateUid(this.props.uids);
    this.state = {
      isModalVisible: false,
      setIsModalVisible: false,
      lookingTickers: false,
      apppath: this.props.paths,
      uid: this.props.uids,
      requestFailed: false,
      exp: false,
      recordcounts: '',
    };
    this.HandleReq = this.HandleReq.bind(this);
    this.HandleReqcount = this.HandleReqcount.bind(this);
    this.HandlePan = this.HandlePan.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    
  }

  HandleReq() {
    this.props.activateScreen(true);
   var  requestOptions= '';
   if (this.props.univtype==1) {
   
      requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  portfolioId : this.props.univid   }),
    };
  
   }
   
   if (this.props.univtype==2) {
      requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  screenId : this.props.univid   }),
    };
  }

  if (this.props.univtype==0) {
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic]    }),
    };
  }
  

  
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
         
          },
          () => {
            this.setState(
              {
                recordcounts: data.filteredData.length,
              })
 
            this.props.activateRecord(data.filteredData.length);
            this.props.activateRecordtb(data.filteredData.length);
            
            
            this.props.activateStocks(data.filteredData )
            this.props.activateScreen(false);
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     
        this.props.activateScreen(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
  }

  componentDidMount() {
    if (this.props.showfilter==1){
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
        
      });
    }
   
  }


  HandleReqcount() {
    this.props.activateScreen(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables: [this.props.datadic.FilterDic], portfolioId: this.props.univid }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data,
         
          },
          () => {
            this.props.activateRecord(data);
            this.props.activateScreen(false);
          
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     
        this.props.activateScreen(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
  }

  onClick = () => {
 
    this.child.current.getall();
  };


    HandlePan = (e) => {
      console.log(e)
    if (this.state.exp==true){
    this.setState({
      exp: false,
     });
    }else{
      this.setState({
        exp: true,
       });
    }
  }
  handleMenuClick(e) {
    window.location.href = this.props.paths+'/login/completelogout';
  }
  render() {
  
    const { loadings } = this.state;
    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
        loadings: [],
      });
    };
    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

  

     
 

    
    
    var compo = [];
    var coltype = '';
    if (this.props.datadic.FilterDic != undefined) {
      console.log( this.props.datadic.FilterDic.columns)
      this.props.datadic.FilterDic.columns.map((experience, i) => {
        if (experience.type == "slider" && experience.selectedUI == 1) {
       
          if (experience.typeCol.toLowerCase() =='percentile'){
            coltype='percentile';
             console.log('percentile')
           }
           if (experience.typeCol.toLowerCase() =='absolute'){
            coltype='absolute';
            console.log('absolute')
       
           }
           console.log('VVVVVVVVVVV',coltype)
          compo[i] = <Sliderlo filtermt={compo.length} id={i} pass={experience} coltype={coltype} colNameId={experience.colNameId}></Sliderlo>;
        }
        if (experience.type == "sliderPrice" && experience.selectedUI == 1) {
          compo[i] = <Selection filtermt={compo.length} id={i} pass={experience}></Selection>;
        }


        if (experience.type == "toggle" && experience.selectedUI == 1) {
          compo[i] = <Togglecom filtermt={compo.length} id={i} pass={experience}></Togglecom>;
        }


        
        if (experience.type == "checkbox" && experience.selectedUI == 1) {
          compo[i] = <Checkboxs filtermt={compo.length} id={i} pass={experience}></Checkboxs>;
        }
        
        if (
          experience.type == "dropdownTr" &&
          experience.selectedUI == 1 &&
          experience.label != "Industry"
        ) {
          compo[i] = <DropDwnTr filtermt={compo.length} id={i} pass={experience}></DropDwnTr>;
        }
        if (experience.type == "bubbleSlider" && experience.selectedUI == 1) {
          compo[i] = <Sliderbub filtermt={compo.length} id={i} pass={experience}></Sliderbub>;
        }
        
        if (experience.type == "dropdown" && experience.selectedUI == 1) {
          compo[i] = <Dropdowns filtermt={compo.length} id={i} pass={experience}></Dropdowns>;
        }

        
      });
      
    }
 
    const gridStyle = {
      width: "100%",
    };

    const ButtonStyle = {
      width: "100px",
      marginLeft: "20%",
      marginTop: "2%",
    };

    const resultsStyle = {
      width: "100px",
      fontWeight: "800",
    };
    const resultfontsStyle = {
      width: "100%",
      fontWeight: "800",
      fontSize: "22px",
    };
      

    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="1">Log Out</Menu.Item>
      
      </Menu>
    );

    return (
   
      <div className="Home">
      
        <Layout className="layout">
         {/*  <Header>
            <Row>
              <Col span={8}></Col>
              <Col span={8}>
                <Fselectf filtermt={compo.length} modalShow={this.state.isModalVisible}></Fselectf>{" "}
              </Col>
              <Col span={8}></Col>
            </Row>
          </Header> */}
       {/*    <PageHeader
          backIcon={false}
          title=""
          breadcrumb={{ routes }}
         
          tags={<em color="blue">Data as of {this.props.dod}</em>}
      ghost={true}
      
      onBack={() => window.history.back()}
   
      extra={[
        <Fselectf filtermt={compo.length} modalShow={this.state.isModalVisible}></Fselectf>,
      ]}
    >
    
    </PageHeader> */}
    <div className="headerclass">
         <div className="logo">
                
                 <img src={ 'https://www.aaii.com/images/lp/aaiilogo.png'}   />  
              
        </div>
        
    
     {this.props.uname!=''?  <div  className="logoLogin" >
     <a href={'https://youtu.be/fdzFFDLy86k'}  target="_blank">
     <Button type="primary" icon={<PlayCircleTwoTone  />}>
      Intro Video
    </Button>
    </a>
    {' ' }
     <a href={this.props.paths+'/contact/webdeptsimpless'}>
     < Button   className="bcolo"  ghost    >
     Stock Screener Feedback 
    </ Button>
      </a>
      {' ' }
     <Dropdown.Button overlay={menu}  className="bcolo"  ghost icon={<UserOutlined  />}>
      <span style={{textTransform: 'capitalize'}}>Welcome, {this.props.uname}</span>
    </Dropdown.Button>  </div>
    : <div  className="logoLogin2" ><a href="/join"><Button    className='orgbutton'>
    Subscribe
   </Button></a>{' '}
   <a href={this.props.paths+'/o/login_aaii?dest=/stockideas/customscreener'}>
   <Button   ghost icon={<UserOutlined  />}>
   Login
  </Button></a> </div> }
  
  

    </div>
    <div className="backaaii" ><a href={this.props.paths} >Back to AAII.com</a></div>
    <div className="ssslogo"> <img src={ 'https://www.aaii.com/images/lp/sss.png'} /> <span className="logotext">AAII Custom Stock Screener </span>
    <span className="beta">BETA</span></div>
     {this.props.plus!=''? 
  <div className='screenMen' >
    <div className='screennames'><ScreenMenu sname={this.props.finame}   showModal={showModal}></ScreenMenu></div>
 
    <Myportfolio></Myportfolio>
  
   { <div className='screenButton'>  <Fselectf showModal={showModal}   filtermt={compo.length} handleCancel={handleCancel} isModalVisible={this.state.isModalVisible}></Fselectf></div>  }
  
   </div> 
 :''}

{this.props.plus!=''?  <div className="dataasof"><em>Data as of {this.props.dod}</em></div>:''}
       {this.props.plus!=''?   <Content>
         
            <div className="scroll">
              {compo.length == 0 ? (
                <div>
                  <Row>
                    <Col span={8}></Col>
                    <Col span={8}>
                      No filters selected. Add a few filters to get results
                    </Col>
                    <Col span={8}></Col>{" "}
                  </Row>
                </div>
              ) : (
                <Collapse defaultActiveKey={['1']}   bordered={false}  onChange={(e) => { this.HandlePan(e) } } >
                <Panel header={this.state.exp==true?"Show Filters":"Hide Filters"} key="1"  >
                <div>
                  {" "}
                  <Row>
                    {" "}
                    <Col span={1}></Col>{" "}
                    <Col span={14}>
                      <div style={gridStyle} >{compo}</div>{" "}
                    </Col>
                    <Col span={8} style={resultsStyle}>
                      {this.props.record != "" ? "Estimated Results" : ""}{" "}
                      <div style={resultfontsStyle}>
                        {this.props.record != "" ? this.props.record : ""}
                      </div>
                      <div>
                        <Space>
                          <Button
                            type="primary"
                            onClick={this.HandleReq}
                            loading={this.props.screen}
                            style={{marginLeft:'12px'}}
                            size={'large'}
                          >
                           Apply Filters
                          </Button>
                          <Button style={{display:'none'}}
                            type="primary"
                            onClick={this.HandleReqcount}
                            loading={this.props.screen}
                          >
                            How Many
                          </Button>
                          <SaveFilter></SaveFilter>
                        </Space>
                      </div>
                    </Col>
                  </Row>{" "}
                </div>
                </Panel>            
            </Collapse> 
              )}
            </div>
            
          </Content>
          : 
          
         ''
          
          }
         
        </Layout>
     {/*    <Link to="/tbs">with hash</Link>  */}
     {this.props.plus!=''?    <TableAPP recordcounts={this.props.record} mys={this.state.my} dodxl={this.props.dodxl}></TableAPP> :''}
   {this.props.mgt==1? <Popmsg  showModal={showModal}  ></Popmsg>:''}
    {/*  {this.props.uname!=''?    '':
     
     <div className="adv">
       <h1>Example Title: 3 Dividend Winners</h1>
    <p> Sign up to get our free report, Three Dividend Stocks for Generating Consistent Quarterly Income,
      to start building your dividend investing portfolio.</p><p> This report will help you identify which traits 
      point to dividend growth and capital appreciation as well as explain how AAII can help you achieve your
       financial goals.</p></div>
     
     } */}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  recordtb: state.recordtb,
  uid: state.auid,
  finame: state.finame,
  screen: state.screen,
  datadicbackup: state.datadicbackup,
  showfilter: state.showfilter,
  univid: state.univid,
  univtype: state.univtype,
 
});

const mapDispatchToProps = {
  activateDatadic,
  activatePath,
  activateStocks,
  activateRecord,
  activateUid,
  activateDatadicbackup,
  activateFiname,
  activateScreen,
  activateShowfilter,
  activateRecordtb,
  activateUnivid,
  activateUnivtype,
};

const Home = connect(mapStateToProps, mapDispatchToProps)(Homeclass);

export default Home;
